module.exports = __webpack_public_path__ + "static/media/ying.a5b3da80.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/ying.gif
// module id = 404
// module chunks = 0